import { render, staticRenderFns } from "./ykyCodeIndex.vue?vue&type=template&id=012eae16&scoped=true"
import script from "./ykyCodeIndex.vue?vue&type=script&lang=js"
export * from "./ykyCodeIndex.vue?vue&type=script&lang=js"
import style0 from "./ykyCodeIndex.vue?vue&type=style&index=0&id=012eae16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012eae16",
  null
  
)

export default component.exports